import 'react-app-polyfill/stable';

export async function loadPolyfills(): Promise<void> {
  // you can load polyfills asynchronously here
}
